
    import '/mnt/src/components/Collapse/index.md?watch=parent';
    export const demoIndex = {
  ids: ["collapse-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Collapse/index.md?type=demo')
};